import type { Eip1193Provider } from "ethers";
import { BaseWalletAdapter } from "./BaseWalletAdapter";

export class CoinbaseAdapter extends BaseWalletAdapter {
  readonly name = "coinbase";

  get installed(): boolean {
    return Boolean(this.resolveProvider());
  }

  protected resolveProvider(): Eip1193Provider | undefined {
    if (typeof window === "undefined") return undefined;
    const win = window as any;
    if (win.ethereum?.providers?.length) {
      const found = win.ethereum.providers.find((p: any) => p?.isCoinbaseWallet);
      if (found) return found;
    }
    if (win.ethereum?.isCoinbaseWallet) return win.ethereum;
    if (win.coinbaseWalletExtension?.isCoinbaseWallet) return win.coinbaseWalletExtension;
    return undefined;
  }
}
